"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPointerEventButton = void 0;
var EPointerEventButton;
(function (EPointerEventButton) {
    EPointerEventButton[EPointerEventButton["LeftMouse"] = 0] = "LeftMouse";
    EPointerEventButton[EPointerEventButton["TouchContact"] = 0] = "TouchContact";
    EPointerEventButton[EPointerEventButton["PenContact"] = 0] = "PenContact";
    EPointerEventButton[EPointerEventButton["MiddleMouse"] = 1] = "MiddleMouse";
    EPointerEventButton[EPointerEventButton["RightMouse"] = 2] = "RightMouse";
    EPointerEventButton[EPointerEventButton["PenBarrelButton"] = 2] = "PenBarrelButton";
    EPointerEventButton[EPointerEventButton["MouseBack"] = 3] = "MouseBack";
    EPointerEventButton[EPointerEventButton["MouseForward"] = 4] = "MouseForward";
    EPointerEventButton[EPointerEventButton["PenEraser"] = 5] = "PenEraser";
})(EPointerEventButton = exports.EPointerEventButton || (exports.EPointerEventButton = {}));
//# sourceMappingURL=e-pointer-event-button.js.map